import { ArrowRightIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { BookOpenIcon, PlusIcon } from '@heroicons/react/24/outline';

import { Logo } from '@/components/Logo';
import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';

import { useEffect, useState } from 'react';
import srcBet105 from './components/bet105.png';
import srcBet105MarchMadness from './components/bet105marchmadness.png';
import srcBet105Promo from './components/bet105promo.png';

export default Bet105Page;

export function Bet105() {
  const {
    config: { title },
  } = usePageContext();

  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Get the current time
    const now = new Date();

    // Set the specific Saturday date (e.g., March 23, 2025, midnight Pacific Time)
    const saturday = new Date('2025-03-23T07:00:00Z'); // Midnight Pacific Time (UTC+7)

    // Check if the current time is before Saturday midnight
    if (now < saturday) {
      setShowContent(true);
    } else {
      setShowContent(false);
    }
  }, []);

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header
        title="Join bet105 and get $250 RAS credit"
        Icon={BookOpenIcon}
        className="py-2 sm:hidden"
      />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto max-w-2xl space-y-8 pt-20 pb-10 text-center">
            <div className="space-y-8 rounded bg-gradient-to-br bg-zinc-500 from-emerald-500/20 via-cyan-400/10 to-emerald-500/20 p-4 sm:p-8 dark:bg-white/5">
              <div className="mx-auto flex w-fit space-x-4">
                <Logo className="size-12 select-none" />
                <PlusIcon className="h-auto w-6 shrink-0 text-zinc-300" aria-hidden="true" />
                <img
                  src={srcBet105}
                  alt="bet105 logo"
                  title="bet105"
                  className="h-12 w-auto self-center"
                />
              </div>
              <h1 className="font-semibold text-xl text-zinc-100 tracking-tight sm:text-2xl">
                <span>Join bet105 and get $250 RAS credit</span>
              </h1>
              <div className="p-4 text-center text-white">
                <h4>Use the button below and deposit $250 or more to bet105.</h4>
                <a
                  href="https://btone.kelsira.com/?mid=253188_1487328"
                  target="_blank"
                  rel="noreferrer"
                  className="w-full sm:w-auto"
                >
                  <li className="group mt-4 inline-flex w-full flex-row items-center justify-center space-x-0.5 overflow-hidden rounded bg-emerald-500 p-2 px-6 font-medium text-sm text-white ring-1 ring-emerald-500 ring-inset transition hover:bg-emerald-400 sm:w-auto">
                    <span>Join bet105</span>
                    <ChevronRightIcon className="size-5 shrink-0 group-hover:hidden" />
                    <ArrowRightIcon className="hidden size-5 p-px transition-transform group-hover:block" />
                  </li>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="relative mt-8 px-4 sm:mt-0 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc dark:prose-invert mx-auto max-w-prose prose-a:font-semibold prose-a:text-emerald-500 hover:prose-a:text-emerald-600">
            <div className="text-left">
              <h4 className="mb-8">Offer terms & conditions</h4>
              <ul className="list-disc space-y-2 pl-4 text-xs text-zinc-500 dark:text-zinc-400">
                <li>New bet105 customers only.</li>
                <li>RAS's referral link must be used.</li>
                <li>Make first deposit of $250 or more.</li>
                <li>
                  Contact RAS on{' '}
                  <a
                    href="/support-chat"
                    className="text-zinc-500 dark:text-zinc-200 dark:hover:text-zinc-300"
                    target="_self"
                  >
                    Support Chat
                  </a>
                  . Eligibility will be confirmed next business day.
                </li>
                <li>
                  RAS will add $250 to your account balance which will automatically apply toward
                  your next RAS order. Promotional RAS balance is not redeemable for cash.
                </li>
              </ul>
            </div>
            <hr className="h-px border-0 bg-zinc-900/10 dark:bg-white/10" />
            {showContent && (
              <div className="mx-auto h-auto min-w-auto max-w-75">
                <a
                  href="https://btone.kelsira.com/?mid=253188_1487328"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={srcBet105MarchMadness}
                    alt="bet105 March Madness offer"
                    title="bet105 March Madness offer"
                    className="h-auto w-full self-center"
                  />
                </a>
              </div>
            )}
            <h3 className="mb-8">
              bet105 is a sportsbook that allows sharp action (including RAS releases) without
              worrying about being limited or banned
            </h3>
            <ul>
              <li>For winning players</li>
              <li>Reduced juice</li>
              <li>No rollover requirements</li>
              <li>Hassle-free withdrawals</li>
              <li>Crypto based</li>
              <li>2-hour withdrawal times</li>
              <li>Human customer support</li>
            </ul>
            <hr className="h-px border-0 bg-zinc-900/10 dark:bg-white/10" />
            <div className="text-center">
              <h4 className="font-normal">
                Deposit $250 or more to bet105 and use the button below to receive a $250 credit to
                use toward any RAS service.
              </h4>
              <a
                href="https://btone.kelsira.com/?mid=253188_1487328"
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-auto"
              >
                <li className="group mt-4 inline-flex w-full flex-row items-center justify-center space-x-0.5 overflow-hidden rounded bg-emerald-500 p-2 px-6 font-medium text-sm text-white ring-1 ring-emerald-500 ring-inset transition hover:bg-emerald-400 sm:w-auto">
                  <span>Join bet105</span>
                  <ChevronRightIcon className="size-5 shrink-0 group-hover:hidden" />
                  <ArrowRightIcon className="hidden size-5 p-px transition-transform group-hover:block" />
                </li>
              </a>
            </div>
            {showContent && (
              <div className="mx-auto h-auto min-w-auto max-w-75">
                <a
                  href="https://btone.kelsira.com/?mid=253188_1487328"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={srcBet105Promo}
                    alt="bet105 March Madness offer"
                    title="bet105 March Madness offer"
                    className="h-auto w-full self-center"
                  />
                </a>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function Bet105Page() {
  return <Bet105 />;
}
